import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { getVoiceAdminSettings, runVoiceHealthCheck } from '../../../api/backendApi';

export default function TwimlResolverTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');
  const [health, setHealth] = useState(null);

  const refresh = async () => {
    setLoading(true); setError('');
    try {
      const resp = await getVoiceAdminSettings();
      setData(resp?.data || resp || {});
    } catch (e) {
      setError(String(e?.message || 'Failed to load settings'));
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  const onHealth = async () => {
    setChecking(true);
    try {
      const resp = await runVoiceHealthCheck();
      setHealth(resp?.data || resp || {});
    } catch (e) {
      setHealth({ ok: false, error: String(e?.message || 'Health check failed') });
    } finally { setChecking(false); }
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>;
  if (error) return <Box sx={{ color: 'error.main' }}>{error}</Box>;

  const flags = data?.flags || data || {};

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>TwiML App</Typography>
          <Box sx={{ mt: 1, fontSize: 14 }}>
            <div>App SID: <strong>{data?.twimlAppSid || '—'}</strong></div>
            <div>Voice URL: <strong>{data?.voiceUrl || '—'}</strong></div>
            <div>Status Callback URL: <strong>{data?.statusCallbackUrl || '—'}</strong></div>
            <div>Linked Account SID: <strong>{data?.accountSid || '—'}</strong></div>
            <div>Default Fallback Number: <strong>{data?.fallbackNumber || data?.twilioPhoneNumber || '—'}</strong></div>
            <div>Last Health Check: <strong>{data?.lastHealthCheckAt ? new Date(data.lastHealthCheckAt).toLocaleString() : '—'}</strong></div>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Button variant="contained" onClick={onHealth} disabled={checking}>{checking ? 'Checking...' : 'Run Health Check'}</Button>
            {health && (
              <Box sx={{ mt: 1, fontSize: 13, color: health?.ok ? 'success.main' : 'error.main' }}>
                {health?.ok ? 'Health check OK' : `Health check failed: ${health?.error || 'unknown'}`}
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Resolver Flags</Typography>
          <Box sx={{ mt: 1, fontSize: 14 }}>
            <div>NUMBER_RESOLVER_ENABLED: <strong>{String(flags?.NUMBER_RESOLVER_ENABLED ?? flags?.numberResolverEnabled ?? false)}</strong></div>
            <div>SMS_NUMBER_RESOLVER_ENABLED: <strong>{String(flags?.SMS_NUMBER_RESOLVER_ENABLED ?? flags?.smsNumberResolverEnabled ?? false)}</strong></div>
            <div>VOICE_NUMBER_RESOLVER_ENABLED: <strong>{String(flags?.VOICE_NUMBER_RESOLVER_ENABLED ?? flags?.voiceNumberResolverEnabled ?? false)}</strong></div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
